/* ---------- Collection filters (facets) ---------- */
(function () {
  var wrap = document.getElementById('FacetsWrap');
  if (!wrap) return;
  var form = document.getElementById('FacetFilterForm');
  var panel = wrap.querySelector('[data-facets-panel]');
  var toggle = wrap.querySelector('[data-facets-toggle]');

  function buildUrl() {
    var data = new FormData(form);
    var params = [];
    data.forEach(function (value, key) {
      if (value !== '' && value !== null) params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return window.location.pathname + (params.length ? '?' + params.join('&') : '');
  }

  function render(url, push) {
    wrap.classList.add('is-loading');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('ProductGridContainer');
        var newFacets = doc.getElementById('FacetsWrap');
        var grid = document.getElementById('ProductGridContainer');
        if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;
        if (newFacets) {
          var openState = {};
          wrap.querySelectorAll('details.facet').forEach(function (d, i) { openState[i] = d.open; });
          wrap.innerHTML = newFacets.innerHTML;
          wrap.querySelectorAll('details.facet').forEach(function (d, i) { if (openState[i] !== undefined) d.open = openState[i]; });
        }
        if (push) window.history.pushState({ facets: true }, '', url);
        if (window.BX && typeof window.BX.initReveal === 'function') window.BX.initReveal();
        document.dispatchEvent(new CustomEvent('bx:facets:updated'));
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { wrap.classList.remove('is-loading'); bind(); });
  }

  var debounce;
  function onChange() {
    clearTimeout(debounce);
    debounce = setTimeout(function () { render(buildUrl(), true); }, 250);
  }

  function bind() {
    form = document.getElementById('FacetFilterForm');
    panel = wrap.querySelector('[data-facets-panel]');
    toggle = wrap.querySelector('[data-facets-toggle]');
    if (!form) return;
    if (toggle && panel) {
      if (panel.hidden && wrap.querySelector('.facet__chip')) panel.hidden = false;
      toggle.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', String(!panel.hidden));
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl(), true); });
    form.querySelectorAll('[data-facet-auto]').forEach(function (el) {
      el.addEventListener(el.tagName === 'INPUT' && el.type === 'number' ? 'change' : 'change', onChange);
    });
    wrap.querySelectorAll('.facet__chip, .facets__actions a').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); render(a.getAttribute('href'), true); });
    });
  }

  bind();
  window.addEventListener('popstate', function () { render(window.location.href, false); });
})();
